// terms.js

const termsData = {
  title: "Terms & Conditions",
  description:
    "Please read these terms carefully before using our platform. By accessing our services, you agree to these conditions.",

  sections: [
    {
      id: 1,
      title: "1. How do we value our customers?",
      content:
        "Our customers are our top priority. We believe in transparent communication, honest listings, and reliable service to help you make confident property decisions.",
    },
    {
      id: 2,
      title: "2. Can I trust the property details?",
      content:
        "We make every effort to display accurate property information. However, prices, images, and availability may change without notice.",
    },
    {
      id: 3,
      title: "3. How accurate is the property information?",
      content:
        "All property details are shared by verified sellers or builders. We recommend users verify details independently before making decisions.",
    },
    {
      id: 4,
      title: "4. What is our role in property deals?",
      content:
        "We act as a platform connecting buyers and sellers. Transactions happen directly between both parties.",
    },
    {
      id: 5,
      title: "5. Are there any hidden costs?",
      content:
        "No hidden charges. All costs and services will always be communicated clearly in advance.",
    },
    {
      id: 6,
      title: "6. What if there’s a dispute?",
      content:
        "We support fair usage, but disputes from transactions must be resolved directly between buyers and sellers.",
    },
    {
      id: 7,
      title: "7. Should I verify property details?",
      content:
        "Yes. Always verify ownership, pricing, and legal documents before making any purchase.",
    },
  ],

  image:
    "https://images.unsplash.com/photo-1450101499163-c8848c66ca85",
};

export default termsData;

